import type { SerializedScenario } from "./tornadoChartJobs";

// Save metadata that changes on every save but that no calculation reads, so
// it is left out of cache keys; otherwise each save would force a full
// recalculation of unchanged inputs. calculationInputsKey.spec.ts checks the
// outputs ignore these fields. Note deleted_at and journal_deleted_at ARE
// read (deleted equipment is skipped), so they must never be added here.
export const IGNORED_FIELDS = new Set([
  "journal_author_id",
  "journal_created_at",
  "journal_updated_at",
  "winning_revision_id",
  "winning_revision_author_id",
  "winning_revision_parent_id",
  "winning_revision_created_at",
  "winning_revision_updated_at",
  "winning_revision_deleted_at",
  "author_id",
  "created_at",
  "updated_at",
  "notes"
]);

// The scenario as JSON, minus IGNORED_FIELDS at any depth.
export const calculationInputsJson = (scenario: SerializedScenario): string =>
  JSON.stringify(scenario, (key, value) =>
    IGNORED_FIELDS.has(key) ? undefined : value
  );

// Short, fixed-size key for caches (scenario JSON can be hundreds of KB).
export const hashKey = async (text: string): Promise<string> => {
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(text)
  );
  return Array.from(new Uint8Array(digest), b =>
    b.toString(16).padStart(2, "0")
  ).join("");
};
